import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/usr/app/src/assets/images/teams/david-chang.1024x1024.jpg");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-read-next.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/partner-werden/partner-werden.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/layout/FooterPublic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/layout/HeaderPublic.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/components/services/ArticleTOC.tsx");
